import { Menu } from "@headlessui/react";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";

const ACTIONS = [
  { key: "accept", label: "Accept", icon: CheckCircleIcon },
  { key: "reject", label: "Reject", icon: XCircleIcon },
];

/**
 * Accept / Reject entries for a pending join request, shared by the Assessment Requests
 * grid menu and the admin Assessment Details menu. Render inside a headless `Menu.Items`.
 */
export default function JoinRequestDecisionMenuItems({ onAccept, onReject, disabled = false }) {
  const handlers = { accept: onAccept, reject: onReject };
  return ACTIONS.map(({ key, label, icon: Icon }) => (
    <Menu.Item key={key}>
      {({ active }) => (
        <button
          type="button"
          disabled={disabled}
          className={`${
            active ? "bg-gray-100 text-gray-900" : "text-gray-700"
          } group flex w-full items-center px-4 py-2 text-sm disabled:opacity-50`}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            handlers[key]();
          }}
        >
          <Icon className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
          {label}
        </button>
      )}
    </Menu.Item>
  ));
}
